import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { BlogCodeBlock } from '@/features/blog/components/BlogCodeBlock'
import { mdxComponents } from '@/features/blog/components/MdxComponents'

interface BlogPostContentProps {
  content: string
}

// Blog-only overrides on top of the shared markdown components (which Docs
// and the admin preview also use), so fenced code gets the console chrome
// without changing how those render.
const blogComponents = { ...mdxComponents, pre: BlogCodeBlock }

// react-markdown parses to an AST and renders it directly — no runtime code
// generation. @mdx-js/mdx's evaluate()/evaluateSync() compile to a JS string
// and execute it via `new Function`/`new AsyncFunction` (see
// node_modules/@mdx-js/mdx/lib/run.js), which Cloudflare Workers blocks
// ("EvalError: Code generation from strings disallowed for this context"),
// crashing this during SSR. Blog posts only use standard markdown (no
// embedded JSX components), so react-markdown's tag-override `components`
// prop covers everything mdxComponents already provides.
export function BlogPostContent({ content }: BlogPostContentProps) {
  return (
    <div className="prose-custom prose-blog max-w-none">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={blogComponents}>
        {content}
      </ReactMarkdown>
    </div>
  )
}
